<template>
  <div class="m-share" v-show="visible">
    <div class="share-mask" @click="handleClose"></div>
    <div class="share-container">
      <div class="close-btn" @click="handleClose"></div>
      <div class="share-title">{{ title }}</div>
      <div class="share-content">{{ content }}</div>
      <div class="share-list">
        <div class="share-item" v-for="item in shareList" :key="item.type" @click="handleShare(item.type, item.rch)">
          <img :src="item.icon" class="share-icon" />
          <p class="share-name">{{ item.name }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: ''
    },
    content: {
      type: String,
      default: ''
    },
    showClose: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      shareList: [
        {
          type: 'moments',
          name: '朋友圈',
          icon: require('@/assets/v2/share-friend.png'),
          rch: 'attOsrtoq',
        },
        {
          type: 'wechat',
          name: '微信好友',
          icon: require('@/assets/v2/share-wechat.png'),
          rch: '7acqa3mig',
        },
        {
          type: 'weibo',
          name: '新浪微博',
          icon: require('@/assets/v2/share-weibo.png'),
          rch: 'vorvtgzhc',
        },
        {
          type: 'qq',
          name: 'QQ',
          icon: require('@/assets/v2/share-qq.png'),
          rch: 'o0pldmaxd',
        },
        {
          type: 'qzone',
          name: 'QQ空间',
          icon: require('@/assets/v2/share-qzone.png'),
          rch: '302u97t6g',
        }
      ]
    }
  },
  computed: {
    visible: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    }
  },
  watch: {
    value(val) {
      if (val) {
        document.body.style.overflow = 'hidden'
      } else {
        document.body.style.overflow = ''
      }
    }
  },
  mounted() {
    if (this.value) {
      document.body.style.overflow = 'hidden'
    }
  },
  beforeDestroy() {
    document.body.style.overflow = ''
  },
  methods: {
    handleClose() {
      this.visible = false
    },
    handleShare(type, rch) {
      this.$emit('share', type, rch)
      this.handleClose()
    }
  }
}
</script>

<style lang="less" scoped>
.m-share {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1000;

  .share-mask {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.4);
  }

  .share-container {
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    background: #FFFFFF;
    border-radius: 36px 36px 0 0;

    .close-btn {
      position: absolute;
      top: 56px;
      right: 56px;
      width: 18px;
      height: 18px;
      background: url('../../assets/v2/dialog-close.png') no-repeat center;
      background-size: contain;
      cursor: pointer;
    }

    .share-title {
      // font-family: AlimamaFangYuanTiVF-Thin;
      font-weight: 600;
      font-size: 32px;
      color: rgba(0, 0, 0, 0.8);
      padding: 48px 0 36px 52px;
      background: linear-gradient( 180deg, rgba(253,176,62,0.2) 0%, rgba(255,211,146,0) 100%);
      border-radius: 36px 36px 0 0;
    }

    .share-content {
      background: rgba(0, 0, 0, 0.03);
      border-radius: 24px;
      font-weight: 400;
      font-size: 22px;
      color: rgba(0, 0, 0, 0.4);
      margin-bottom: 36px;
      padding: 36px 48px;
      margin: 0 36px 36px;
    }

    .share-list {
      display: flex;
      justify-content: space-between;
      padding: 0 12px;
      margin: 0 36px 92px;

      .share-item {
        display: flex;
        flex-direction: column;
        align-items: center;
        cursor: pointer;

        .share-icon {
          width: 102px;
          height: 102px;
          margin-bottom: 12px;
        }

        .share-name {
          font-weight: 400;
          font-size: 24px;
          color: rgba(0, 0, 0, 0.3);
        }
      }
    }
  }
}
</style>
